<script>
    import ViewLogs from "../ViewLogs.svelte";
    import ViewNotes from "../ViewNotes.svelte";
    import {PAGE_ID, router, navigateTo, navigateWithContextTo} from "../../stores/router";
    import {app_state, displayCompany, selectCompany, updateCompany, selectDeal, filemanager} from "../../stores/misc";
    import {
        I_COMPANY,
        companyAsObject,
        getNullCompany, I_DEAL, COMPANY_LABELS
    } from "../../../../../../lib/datatypes";
    import {deepCopyByValue, prettyHTMLFromPlainText} from "../../../../../../lib/utils";
    import DealsList from "../DealsList.svelte";
    import {deals} from "../../stores/deals";
    import FileAttachmentList from "../FileAttachmentList.svelte";


    // 'Empty' display person for use when there is no selected person
    let empty_company_obj = companyAsObject(getNullCompany());

    $: selected_company = $app_state.selected_company_id === null ? empty_company_obj : displayCompany($app_state.selected_company_id);
    let edited_selected_company = null;
    let notes = [];
    let logs = [];
    const resetStateParams = () => {
        edited_selected_company = null;
        notes = [];
        logs = [];
    };
    $: (async () => {
        if($app_state.selected_company_id === null) {
            resetStateParams();
        } else {
            const response = await fetch(`/api/company/${$app_state.selected_company_id}`);
            const result = await response.json();
            notes = result.notes;
            logs = result.log;
        }
    })()

    $: company_deals_arr_list = $deals.list.filter(deal_arr => deal_arr[I_DEAL.ID_COMPANY] == selected_company.id);

    const VIEW_STATE = {
        VIEWING: 0,
        EDITING: 1
    };
    let view_state = VIEW_STATE.VIEWING;

    const TAB_STATE = {
        DEALS: 0,
        NOTES: 1,
        LOG: 2
    };
    let tab_state = TAB_STATE.DEALS;

    const onEditCompanyClick = async () => {
        edited_selected_company = await deepCopyByValue(selected_company);
        // console.log(edited_selected_company);
        view_state = VIEW_STATE.EDITING;
    };

    const resetEditingCompany = () => {
        view_state = VIEW_STATE.VIEWING;
        edited_selected_company = null;
    }
    const saveEditedCompany = async () => {
        if(edited_selected_company === null) console.warn('Trying to save a null edited company!');
        let saved_company = await updateCompany(edited_selected_company);
        selectCompany(saved_company[I_COMPANY.ID]); // ..to reflect the changes made (otherwise doesn't pick it up)
        resetEditingCompany();
    };


    let is_uploading_files = false;
    const doChooseFile = () => {
        filemanager.chooseFiles();
        is_uploading_files = true;
    };
    $: {
        if (is_uploading_files) {
            if ($filemanager.files.length > 0) {
                if (edited_selected_company !== null) {
                    edited_selected_company.files = edited_selected_company.files.concat($filemanager.files);
                    edited_selected_company = edited_selected_company;
                    is_uploading_files = false;
                    filemanager.resetFiles();
                    console.log('files added, full list =', edited_selected_company.files);
                }
            }
        }
    }


    const onBackClick = () => {
        if($router.context.previous_page_id !== null) {
            navigateTo($router.context.previous_page_id);
        }
        else {
            navigateTo(PAGE_ID.COMPANIES);
        }
    };

    const onDealClick = id => {
        selectDeal(id);
        navigateTo(PAGE_ID.VIEW_DEAL, PAGE_ID.VIEW_COMPANY);
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.VIEW_COMPANY}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--<Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center justify-between">
            <a on:click|preventDefault={onBackClick} href="/" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                <svg class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                </svg>
                Back
            </a>
            <div class="flex flex-shrink-0 md:mt-0 md:ml-4">
                <button on:click={onEditCompanyClick}
                        type="button" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Edit</button>
                <!--<button type="button" class="ml-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Publish</button>-->
            </div>
        </div>

    </div>

    <div class="px-4 sm:px-6 lg:px-8">
        {#if view_state === VIEW_STATE.VIEWING}

            <!-- Company pill-->
            <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
                <svg class="h-4 w-4 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4 16.5v-13h-.25a.75.75 0 010-1.5h12.5a.75.75 0 010 1.5H16v13h.25a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-3.5a.75.75 0 010-1.5H4zm3-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM7.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM11 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z" clip-rule="evenodd" />
                </svg>
                <p class="ml-1 text-sm uppercase font-light text-gray-600">Company</p>
            </div>

            <div class="mt-4">
                <h1 class="text-2xl font-bold text-gray-900">{selected_company.name}</h1>
            </div>

            <p class="mt-4 text-gray-900">
                {@html prettyHTMLFromPlainText(selected_company.description)}
            </p>

            {#if selected_company.files.length > 0}
                <div class="my-4">
                    <p class="mt-4 text-sm text-gray-500">Files:</p>
                    <FileAttachmentList files={selected_company.files}></FileAttachmentList>
                </div>
            {/if}

        {/if}
        {#if view_state === VIEW_STATE.EDITING}
            <div class="sm:col-span-3">
                <label for="company-name" class="block text-sm font-medium text-gray-900">Name</label>
                <input bind:value="{edited_selected_company.name}" type="text" name="company-name" id="company-name" autocomplete="company-name" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
            </div>

            <div class="mt-4">
                <label for="description" class="block text-sm font-medium text-gray-900">Description</label>
                <div class="mt-1">
                    <textarea bind:value={edited_selected_company.description}
                              id="description" name="description" rows="4"
                              class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
                </div>
                <p class="mt-3 text-sm italic text-gray-500">({@html COMPANY_LABELS.DESCRIPTION})</p>
            </div>

            <div class="my-4">
                <p class="block text-sm font-medium text-gray-900">Files</p>
                {#if edited_selected_company.files.length > 0}
                    <div class="mt-2">
                        <FileAttachmentList files={edited_selected_company.files}></FileAttachmentList>
                    </div>
                {/if}
                {#if $filemanager.is_uploading}
                    <div class="flex items-center justify-center rounded-md border border-transparent bg-orange-600 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    ><svg class="animate-spin self-center w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                    </svg>
                        Sending..</div>
                {/if}
                <button on:click={doChooseFile}
                        type="button"
                        class="mt-2 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100"
                >Add File</button>
            </div>

            <div class="flex justify-end pt-8">
                <button on:click={resetEditingCompany}
                        type="button"
                        class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >Cancel</button>
                <button on:click={saveEditedCompany}
                        type="submit"
                        class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >Save</button>
            </div>
        {/if}
    </div>

    <div class="block mt-6">
        <div class="border-b border-gray-200">
            <nav class="-mb-px px-4 flex justify-between sm:justify-start space-x-8" aria-label="Tabs">
                <a href="/" on:click|preventDefault={() => tab_state = TAB_STATE.DEALS} class="{tab_state === TAB_STATE.DEALS ? `border-indigo-500 text-indigo-600` : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700` } group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium">
                    <svg class="{tab_state === TAB_STATE.DEALS ? `text-indigo-500` : `text-gray-400 group-hover:text-gray-500`} -ml-0.5 mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.121 7.629A3 3 0 009.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 01-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 011.422 0l.655.218a2.25 2.25 0 001.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Deals</span>
                </a>

                <a href="/" on:click|preventDefault={() => tab_state = TAB_STATE.NOTES} class="{tab_state === TAB_STATE.NOTES ? `border-indigo-500 text-indigo-600` : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700` } group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium">
                    <svg class="{tab_state === TAB_STATE.NOTES ? `text-indigo-500` : `text-gray-400 group-hover:text-gray-500`} -ml-0.5 mr-2 h-5 w-5"  fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                    </svg>
                    <span>Notes</span>
                </a>

                <a href="/" on:click|preventDefault={() => tab_state = TAB_STATE.LOG} class="{tab_state === TAB_STATE.LOG ? `border-indigo-500 text-indigo-600` : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700` } group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium" aria-current="page">
                    <svg class="{tab_state === TAB_STATE.LOG ? `text-indigo-500` : `text-gray-400 group-hover:text-gray-500`} -ml-0.5 mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                    </svg>
                    <span>Log</span>
                </a>
            </nav>
        </div>
    </div>

    {#if tab_state === TAB_STATE.DEALS}
        <div class="px-4 sm:px-6 lg:px-8">

            <DealsList deals_arr_list={company_deals_arr_list} on:dealClicked={e => onDealClick(e.detail.id)}></DealsList>

            <div class="h-16 flex items-center justify-end">
                <div class="flex flex-shrink-0">
                    <button on:click={() => navigateWithContextTo(PAGE_ID.ADD_DEAL, { id_company: selected_company.id }, $router.current_page)}
                            type="button" class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">
                        <!-- Heroicon name: mini/plus -->
                        <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                        </svg>
                        <span>Add Deal</span>
                    </button>
                </div>
            </div>

        </div>
    {/if}

    {#if tab_state === TAB_STATE.NOTES}
    <ViewNotes type="company" owner_id={selected_company.id} bind:notes></ViewNotes>
    {/if}

    {#if tab_state === TAB_STATE.LOG}
    <ViewLogs type="company" owner_id={selected_company.id} bind:logs></ViewLogs>
    {/if}

</div>


<style></style>